import { TextField, MenuItem } from '@mui/material';
import { YEAR_GROUP_OPTIONS } from '../constants/yearGroups';

/**
 * Year group dropdown. Year 4–Year 13. Stored as "Year N".
 * Props mirror MUI TextField — anything you pass (sx, size, helperText,
 * required, fullWidth…) is forwarded.
 *
 *  - allowAny:  show an "Any/None" sentinel item (default true)
 *  - anyLabel:  the sentinel label (default "Any"; pass "— None —" for forms)
 */
export default function YearGroupSelect({
    value,
    onChange,
    label = 'Year group',
    allowAny = true,
    anyLabel = 'Any',
    size = 'small',
    ...rest
}) {
    return (
        <TextField
            select
            size={size}
            label={label}
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            {...rest}
        >
            {allowAny && <MenuItem value="">{anyLabel}</MenuItem>}
            {YEAR_GROUP_OPTIONS.map((y) => (
                <MenuItem key={y} value={y}>
                    {y}
                </MenuItem>
            ))}
        </TextField>
    );
}
